
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/contracts/[category]/[contract]",
      function () {
        return require("private-next-pages/signature/contracts/[category]/[contract].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signature/contracts/[category]/[contract]"])
      });
    }
  